module.exports = __webpack_public_path__ + "static/media/nm____.6a875589.svg";